import shield from '../assets/securityFeatures/mecanisms/shield.png';
import calendar from '../assets/securityFeatures/mecanisms/calendar.png';
import moneyback from '../assets/securityFeatures/mecanisms/moneyback.png';
import verified from '../assets/securityFeatures/mecanisms/verified.png';

import clubAtlante from '../assets/securityFeatures/partnerships/clubAtlante.png';
import clubQueretaro from '../assets/securityFeatures/partnerships/clubQueretaro.png';
import clubSantos from '../assets/securityFeatures/partnerships/clubSantos.png';
import fronticket from '../assets/securityFeatures/partnerships/fronticket.png';
import fronton from '../assets/securityFeatures/partnerships/fronton.png';
import algodoneros from '../assets/securityFeatures/partnerships/algodoneros.png';
import mazatlan from '../assets/securityFeatures/partnerships/mazatlan.png';
import canal6 from '../assets/securityFeatures/partnerships/canal6.png';
import funticket from '../assets/securityFeatures/partnerships/funticket.png';
import musicvibe from '../assets/securityFeatures/partnerships/musicvibe.png';
import ch from '../assets/securityFeatures/partnerships/ch.png';

export const mechanismsData = [
  {
    id: '3dSecure',
    image: shield,
    title: '3D Secure en tus pagos',
    supportingText:
      'A través de la aplicación de oasis, todas tus compras están seguras. Nuestra plataforma utiliza tecnologías de vanguardia que todos los bancos de México utilizan. Mediante 3D Secure, solo tú puedes hacer compras con tu tarjeta. Nosotros nunca guardamos tu información de pago.',
  },
  {
    id: 'verifiedBoxes',
    image: verified,
    title: 'Palcos Verificados',
    supportingText:
      'Todos los palcos listados en nuestra plataforma están verificados por nuestro equipo para comprobar su veracidad y legitimidad en todos los aspectos. Todos y cada uno de los palcos son 100% reales al igual que sus rentas. Evento que reserves por Oasis será un evento al que asistirás sin inconvenientes de fraudes.',
  },
  {
    id: 'customersupport',
    image: calendar,
    title: 'Atención 24/7',
    supportingText:
      'Una vez agendada una reserva, se te asignara un Concierge Oasis que estará a tu disposición 24/7, donde este se ocupara de todos los inconvenientes que puedas tener relacionadas con tu reserva.',
  },
  {
    id: 'cancellation',
    image: moneyback,
    title: 'Políticas de Cancelación',
    supportingText:
      'En caso que el evento reservado tenga que ser cancelado por causas de fuerza mayor como COVID o que su aforo se disminuya, recibirás el 100% de tu dinero, o la cantidad proporcional por boleto que haya sido disminuido.',
  },
];

export const partnersData = [
  {
    id: 'clubSantos',
    image: clubSantos,
  },
  {
    id: 'clubQueretaro',
    image: clubQueretaro,
  },
  {
    id: 'clubAtlante',
    image: clubAtlante,
  },
  {
    id: 'fronton',
    image: fronton,
  },
  {
    id: 'fronticket',
    image: fronticket,
  },
  {
    id: 'algodoneros',
    image: algodoneros,
  },
  {
    id: 'mazatlan',
    image: mazatlan,
  },
  {
    id: 'canal6',
    image: canal6,
  },
  {
    id: 'funticket',
    image: funticket,
  },
  {
    id: 'musicvibe',
    image: musicvibe,
  },
  {
    id: 'ch',
    image: ch,
  },
];
